// All action times

const roomRecordings = {
    REQUEST_ROOM_RECORDINGS: 'REQUEST_ROOM_RECORDINGS',
    RECEIVE_ROOM_RECORDINGS: 'RECEIVE_ROOM_RECORDINGS',
    SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
    CLEAR_ERRORS: 'CLEAR_ERRORS'
  };
  
  export default roomRecordings;


// WEBPACK FOOTER //
// src/routes/RoomRecordings/actions/actiontypes.js